import { validateBirthDate } from '../../../validations/birthDate';
import { doTagInvalidBirthday } from '../../../tagging';
import { useState } from 'react';

export const useBirthdayValidation = ({ userProfile, formActions, handleIsOlder, handleIsVulnerablyOlder }) => {
    const [isValidDate, setIsValidDate] = useState(true);

    const handleValidateBirthDate = () => {
        const { birthDay, birthMonth, birthYear, password } = userProfile;
        const { isValid, isOlder, isVulnerablyOlder, dateString, actionsToDispatch } = validateBirthDate({
            birthDay,
            birthMonth,
            birthYear,
            password,
        });
        setIsValidDate(isValid);
        handleIsVulnerablyOlder(!!(isValid && isVulnerablyOlder));

        if (actionsToDispatch.length) {
            actionsToDispatch.forEach(({ field, validation }) => {
                formActions.setValidity(`userProfile.${field}`, { [validation]: isValid });
            });

            return;
        }

        formActions.change('userProfile.birthDate', dateString);
        formActions.change('userProfile.isOlder', isOlder);
        formActions.setValidity('userProfile.birthDate', {
            valid: isValid,
            older: isOlder,
        });

        handleIsOlder(isOlder);

        if (isValidDate) {
            formActions.setValidity('userProfile.birthDay', {
                required: true,
            });
            formActions.setValidity('userProfile.birthMonth', {
                required: true,
            });
            formActions.setValidity('userProfile.birthYear', {
                required: true,
            });
        } else {
            doTagInvalidBirthday(userProfile);
        }
    };

    return { isValidDate, handleValidateBirthDate };
};
